import { useEffect, useState } from 'react';

const BUILD_ID = process.env.REACT_APP_BUILD_ID;
const POLL_MS = 5 * 60 * 1000; // 5 minutes

export function useVersionCheck(): { updateAvailable: boolean } {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    // No baked-in id (dev build) → nothing to compare against.
    if (!BUILD_ID) return;

    let cancelled = false;

    const check = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { buildId } = await res.json();
        if (!cancelled && buildId && buildId !== BUILD_ID) {
          setUpdateAvailable(true);
        }
      } catch {
        // Offline or transient error — ignore, try again next tick.
      }
    };

    check(); // on mount
    const interval = setInterval(check, POLL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return { updateAvailable };
}
